import { render, staticRenderFns } from "./PatrolManagement.vue?vue&type=template&id=6583a912&scoped=true"
import script from "./PatrolManagement.vue?vue&type=script&lang=js"
export * from "./PatrolManagement.vue?vue&type=script&lang=js"
import style0 from "./PatrolManagement.vue?vue&type=style&index=0&id=6583a912&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6583a912",
  null
  
)

export default component.exports